import React from "react";
import { Layout } from "../layout";
import { makeStyles } from "@material-ui/core/styles";
import { Button, Grid } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import { ROUTES } from "~/const/route";

export const SpecialistLogout: React.VFC = () => {
  const classes = useStyles();
  const history = useHistory();
  const navigateLogin = () => history.push(ROUTES.SPECIALIST.LOGIN);

  return (
    <Layout>
      <Grid
        className={classes.container}
        container
        alignItems="center"
        justify="center"
      >
        <div>
          <h1 className={classes.h1}>ログアウトしました</h1>
          <p className={classes.p}>
            もう一度情報を見る場合は再度ログインしてください。
          </p>
          <Button
            className={classes.button}
            variant="contained"
            color="secondary"
            onClick={navigateLogin}
          >
            ログイン
          </Button>
        </div>
      </Grid>
    </Layout>
  );
};

const useStyles = makeStyles({
  container: {
    minHeight: "calc(100vh - 128px)",
  },
  h1: {
    fontSize: 34,
    fontWeight: "normal",
    margin: 0,
  },
  p: {
    fontSize: 20,
    margin: 0,
    marginTop: 15,
  },
  button: {
    display: "block",
    width: 128,
    margin: "auto",
    marginTop: 70,
  },
});
